import React from 'react'
import BaseComponent from './BaseComponent'

export default class extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { value: "", todos: [], preloader: true }
    this._bind('addTodo', 'removeTodo', 'updateTodo', 'changeInput', 'getTodos')
  }

  componentDidMount() {
    this.getTodos()
  }

  getTodos() {
    this.setState({ preloader: true })
    fetch(this.props.API+"/api/admin/data/list/todo", {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        }
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      let res = result.data.result
      if (res === null || res === false) {
        res = []
      }
      this.setState({ todos: res, value: "", preloader: false })
    }, (error) => {
      console.log(error)
    })
  }

  changeInput(e) {
    this.setState({ value: e.target.value })
  }

  addTodo() {
    if (this.state.value !== "") {
      this.setState({ preloader: true })
      let params = { description: this.state.value }

      fetch(this.props.API+"/api/admin/data/create/todo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        //console.log(result)
        this.getTodos()
      }, (error) => {
        console.log(error)
      })
    }
  }

  updateTodo(id, value) {
    this.setState({ preloader: true })
    let params = { id: id, checked: value }
    fetch(this.props.API+"/api/admin/data/update/todo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.getTodos()
    }, (error) => {
      console.log(error)
    })
  }

  removeTodo(id) {
    this.setState({ preloader: true })
    let params = { "id": id }
    fetch(this.props.API+"/api/admin/data/delete/todo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.getTodos()
      
    }, (error) => {
      console.log(error)
    })
  }

  render () {
    let todos = this.state.todos.map((item, i) => {
      return (
        <li key={ i } onClick={ this.updateTodo.bind(null, item.id, item.checked === "1" ? "0" : "1") } className={ item.checked === "1" ? "item checked" : "item" }>{ item.description }<div className="delete-todo" onClick={ this.removeTodo.bind(null, item.id) }><img src="./assets/img/icons/delete.png" alt=""/></div></li>
      )
    })

    return (
      <div className="todos">
        <div className="todo-input">
          <input type="text" value={ this.state.value } onChange={ this.changeInput } onKeyDown={ (e) => { e.persist(); if (e.keyCode === 13) { this.addTodo() } } } autoFocus placeholder="Wpisz tutaj 'todo' aby dodać"/>
          <button onClick={ this.addTodo } className="add">+</button>
        </div>
        <ul className="todo-list">
          { todos }
        </ul>
        { this.state.preloader ? <div className="preloader"><span></span></div> : null }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Todos.js